import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyADcnPasXyhdiUK-4pauoP-TvBpnS0-mZQ",
  authDomain: "hpt-framework.firebaseapp.com",
  projectId: "hpt-framework",
  storageBucket: "hpt-framework.firebasestorage.app",
  messagingSenderId: "853208462389",
  appId: "1:853208462389:web:2b170b4e665c20b70cad7c"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
